// All available configuration fields and groups for Production graph
export const LostProductionGraphFields = {
  // Show [affects field visibility]
  GROUP_SHOW: 'Show',
  TOTAL: 'Total',
};

// Production graph field definitions
export const lostProductionGraphFieldDefs = {
  [LostProductionGraphFields.GROUP_SHOW]: {
    labels: [
      {
        a11yKey: 'production_graph.show',
        a11yDefault: 'Show',
      },
    ],
    fields: {
      [LostProductionGraphFields.TOTAL]: {
        labels: [
          {
            a11yKey: 'production_graph.total',
            a11yDefault: 'Total',
          },
        ],
      },
    },
  },
};

// Default order and visibility configuration for Production graph fields
// NOTE: For state selection, EVERY field must have a position and visibility default!
export const lostProductionGraphDefaultConfig = [
  {
    id: LostProductionGraphFields.GROUP_SHOW,
    fields: [
      {
        id: LostProductionGraphFields.TOTAL,
        visible: true,
      },
    ],
  },
];
